<template>
  <div align="center" class="container-fluid">
    <page-header></page-header>
    <div class="navbar_website_map">
      <img src="../../assets/img/jt.jpg" width="9" height="9" />
      {{ $t("currlocation") }}:
      <router-link :to="{ name: 'login' }">{{ $t("index") }}</router-link>
      <img src="../../assets/img/jt.gif" /><a href="javascript:history.go(-1)">{{ $t("anonymou_currpage") }}</a>
      <img src="../../assets/img/jt.gif" />{{ $t("anonymoudetail_title") }}
    </div>
    <div style="min-height: 450px;">
      <table-no-record v-if="JSON.stringify(records)=='{}'"></table-no-record>
      <table width="98%" cellpadding="1" cellspacing="1" class="main_talbe" v-if="JSON.stringify(records.listTo)!='{}'">
        <!--DWLayoutTable-->
        <tr class="trtitle">
          <td width="16%" height="20" valign="middle"> {{ $t("anonymou_house_no") }} </td>
          <td width="7%">{{ $t("anonymou_orgn_code") }}</td>
          <td width="7%">{{ $t("anonymou_dest_code") }} </td>
          <td width="6%">{{ $t("anonymou_qty") }} </td>
          <td width="6%">{{ $t("anonymou_gw") }} </td>
          <td width="6%">{{ $t("anonymou_vw") }}</td>
          <td width="12%">{{ $t("normal_state_dates31") }}</td>
          <td width="12%">{{ $t("anonymou_state_dates33") }}</td>
          <td width="16%">{{ $t("normal_detail") }} </td>
          <td width="8%">{{ $t("document_word1") }}</td>
        </tr>
        <tr v-for="(item,i) in records.listTo" :key="i" class="tr2" onmouseover="this.className='shen'" onmouseout="this.className='tr2'">
          <td height="18" valign="middle"><a>{{ item.houseNo }}</a> </td>
          <td>{{ item.orgnCode }}</td>
          <td>{{ item.destCode }}</td>
          <td>{{ item.qty }}</td>
          <td>{{ item.gw }}</td>
          <td><span v-if="query.AwbBlType=='S'">{{item.cbm}}</span> <span v-if="query.AwbBlType=='A'">{{item.vw}}</span></td>
          <td> {{item.stateDates31}} &nbsp; {{item.stateTimes31}}</td>
          <td> {{item.stateDates33}} &nbsp; {{item.stateTimes33}}</td>
          <td>
            <span v-if="query.AwbBlType=='S'"><a>{{ $t("normal_word2") }} </a></span>
            <span v-if="query.AwbBlType=='A'"> {{ $t("normal_word2") }} </span> |
            <span> <a>{{ $t("normal_word3") }}</a> </span> |
            <span> <a>{{ $t("normal_word4") }}</a> </span> |
            <span> <a>{{ $t("normal_word5") }}</a> </span>
          </td>

          <td><a>{{ $t("document_word2") }}</a>   | <a> {{ $t("document_word3") }} </a> </td>
        </tr>
      </table>

      <pagination v-if="JSON.stringify(records)!='{}'" :total="records.totalLength" @current-change="changePage" :pageSize="50" :current-page="records.row"></pagination>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageFooter from "@/components/infrastructure/layout/page-footer.vue";
import PageHeader from "@/components/infrastructure/layout/page-header.vue";
import TableNoRecord from "@/components/infrastructure/table/table-no-record.vue";
import Pagination from "@/components/infrastructure/pagination/index.vue";
import { GetAirfreightQuery } from "@/api/branchBillOflading.js";
import StateCode from "@/components/infrastructure/layout/state-code.vue";
import { mapActions } from "vuex";
export default {
  components: {
    PageHeader,
    PageFooter,
    TableNoRecord,
    Pagination,
    StateCode,
  },
  data() {
    return {
      query: {
        AwbBlType: "",
        Row: "50",
        Page: "1",
      },
      records: {},
    };
  },
  async mounted() {
    this.query.AwbBlType = this.$route.query.AwbBlType;
    await GetAirfreightQuery(this.query).then((res) => {
      if (res.code == 200) {
        this.records = res.data;
      }
    });
  },
};
</script>
<style lang="less">
</style>